import { Component, OnDestroy, OnInit } from '@angular/core';
import { MONTHS } from '@home/src/app/enums/Date';
import { BaseErrorComponent } from '../../baseerror/baseerror.component';
import { Subject, takeUntil } from 'rxjs';
import { GlobalService } from '@home/src/app/core/services/global/global.service';
import { CommonModule } from '@angular/common';
import { CustomDateSelectComponent } from '@home/src/app/shared/components/custom-date-select/custom-date-select.component';
import { FormsModule } from '@angular/forms';
import { CustomReportService } from '@home/src/app/core/services/CustomReport/custom-report.service';
import { GroupMember } from '@home/src/app/Interface/Dealer';
import { environment } from '@home/src/app/environments/environment';
import { AuthenticationService } from '@home/src/app/core/services/Auth/authservice';
@Component({
  selector: 'app-custom-report',
  standalone: true,
  imports: [CustomDateSelectComponent, CommonModule, FormsModule],
  templateUrl: './custom-report.component.html',
  styleUrl: './custom-report.component.css',
})
export class CustomReportComponent
  extends BaseErrorComponent
  implements OnInit, OnDestroy
{
  protected readonly unsubscribe$ = new Subject<void>();

  period: boolean = true;
  noDataFound: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';
  public currentDate: string = `${new Date().getMonth() + 1} ${new Date().getDate()}, ${new Date().getFullYear()}`;
  public processingMonth: string = '';
  currentYear = new Date().getFullYear();
  minDate: Date = new Date(this.currentYear - 3, 0, 1);
  maxDate: Date = new Date(this.currentYear + 1, 11, 31);
  selectedDate: Date = new Date();
  selectedDealer: GroupMember | null = null;
  private readonly destroy$ = new Subject<void>();
  customReportData: any = null;
  dealersList: any;
  groupAverageList: any = [];
  pageGroupingList: any;
  bocList: any = [];
  pagesList: any = [];
  checkboxModel: any = {};
  authUser: any;
  groupCode: any;
  fincomdata: any;
  get processingMonthYear(): string {
    if (!this.selectedDate) return '';
    const month = MONTHS[this.selectedDate.getMonth()];
    return `${month} ${this.selectedDate.getFullYear()}`;
  }

  constructor(
    private globalService: GlobalService,
    private customReportService: CustomReportService,
    private authService: AuthenticationService,
  ) {
    super();
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }

  async ngOnInit() {
    const fincomDataString = sessionStorage.getItem('fincomData');
    if (fincomDataString) {
      const fincomData = JSON.parse(fincomDataString);
      this.fincomdata = fincomData;
      this.groupCode = fincomData.committeeCode;
    }
    this.authService.fincomData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((state) => {
        this.fincomdata = state;
        if (state && state['committeeCode']) {
          this.groupCode = state['committeeCode'];
        }
      });
    this.globalService.selectedDealer$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: GroupMember | null) => {
        this.selectedDealer = data || null;
        this.fetchGroupCompositeDetails();
      });
  }

  async onDateSelected(date: Date) {
    this.selectedDate = date;
    this.fetchGroupCompositeDetails();
  }
  get isAnyPrimaryChecked(): boolean {
    return this.dealersList?.some((d: any) => d.selected) ?? false;
  }

  async fetchGroupCompositeDetails() {
    if (!this.selectedDealer) {
      this.errorMessage = 'Please select a dealer.';
      return;
    }

    const isLocalhost = window.location.hostname === 'localhost';
    let url = `${environment.groupCompositeDetails}?Group_Code=${this.groupCode}&Month=${this.selectedDate.getMonth() + 1}&Year=${this.selectedDate.getFullYear()}`;
    if (isLocalhost) {
      url += `&code=${environment.functionappCode}`;
    }

    try {
      const response = await this.customReportService.getGroupComposites(url);
      if (response.statusCode === 200) {
        this.customReportData = response.data;
        this.successMessage = 'Data fetched successfully!';
        this.dealersList = this.customReportData?.data.dealersData ?? [];
        this.pagesList = (this.customReportData?.data.Pages ?? []).map(
          (p: any) => ({
            ...p,
            IsComposite: p.IsComposite ?? true,
            IsIncluded: p.IsIncluded ?? false,
            selected: p.IsIncluded !== false,
          }),
        );

        this.groupAverageList = [
          { name: 'Custom Average', selected: true },
          { name: 'Original Group Average', selected: true },
        ];
        this.pageGroupingList =
          this.customReportData?.data.PageGroupingList ?? [];
        this.bocList = this.customReportData?.data.BOCList ?? [];

        this.dealersList.forEach((d: any) => {
          d.selected = d.IsIncluded === true;
        });

        this.pagesList.forEach((p: any) => {
          p.selected = p.IsIncluded === true;
        });

        this.bocList.forEach((b: any) => {
          b.selected = b.IsIncluded === true;
        });

        this.checkboxModel = {};
        this.pageGroupingList.forEach((pg: any) => {
          this.checkboxModel[pg.PageGrouping_Type_Id] = {
            E: false,
            P: false,
          };
        });
      } else {
        this.errorMessage = `Error fetching data: ${response.statusCode}`;
        this.globalService.showToast(this.errorMessage, 'error');
      }
    } catch (error) {
      console.error('Error fetching group composite details:', error);
      this.errorMessage = 'An error occurred while fetching data.';
      this.globalService.showToast(this.errorMessage, 'error');
    }
  }

  get areAllBocSelected(): boolean {
    return (
      this.bocList.length > 0 && this.bocList.every((b: any) => b.selected)
    );
  }
  get hasSelectableDealers(): boolean {
    return this.dealersList?.some((d: any) => d.IsComposite) ?? false;
  }
  onPrimarySelectionChange() {
    const anyDealerSelected = this.isAnyDealerSelected;

    if (!anyDealerSelected) {
      this.groupAverageList.forEach((g: any) => (g.selected = false));
    }

    const anySelected =
      anyDealerSelected ||
      this.groupAverageList.some((g: any) => g.selected) ||
      this.bocList.some((b: any) => b.selected) ||
      this.pagesList.some((k: any) => k.selected);
    if (!anySelected) {
      Object.keys(this.checkboxModel).forEach((key) => {
        this.checkboxModel[key].E = false;
        this.checkboxModel[key].P = false;
      });
    }
  }
  get isAnyDealerSelected(): boolean {
    return this.dealersList?.some((d: any) => d.selected) ?? false;
  }
  get areAllDealersSelected(): boolean {
    const selectable = this.dealersList?.filter((d: any) => d.IsComposite);
    return selectable?.length > 0 && selectable.every((d: any) => d.selected);
  }
  get areAllGroupAvgSelected(): boolean {
    return (
      this.groupAverageList?.length > 0 &&
      this.groupAverageList?.every((g: any) => g.selected)
    );
  }
  get areAllPagesSelected(): boolean {
    const selectable = this.pagesList?.filter((d: any) => d.IsComposite);
    return selectable?.length > 0 && selectable?.every((d: any) => d.selected);
  }

  toggleSelectAll(
    type: 'dealers' | 'group' | 'boc' | 'pagelist',
    event: any,
  ): void {
    const isChecked = event.target.checked;

    if (type === 'dealers') {
      this.dealersList
        .filter((d: any) => d.IsComposite)
        .forEach((d: any) => (d.selected = isChecked));
    }

    if (type === 'group') {
      this.groupAverageList.forEach((g: any) => (g.selected = isChecked));
    }

    if (type === 'boc') {
      this.bocList.forEach((b: any) => (b.selected = isChecked));
    }

    if (type === 'pagelist') {
      this.pagesList
        .filter((d: any) => d.IsComposite)
        .forEach((d: any) => (d.selected = isChecked));
    }

    this.onPrimarySelectionChange();
  }
  async generateReports() {
    const selectedDealers = this.dealersList
      .filter((d: any) => d.selected)
      .map((d: any) => ({
        Composite_Id: d.Composite_Id,
        GroupMemberCode: d.GroupMemberCode,
      }));
    const includeCustomAverage = this.groupAverageList.some(
      (g: any) => g.name === 'Custom Average' && g.selected === true,
    );
    const includeOriginalGroupAverage = this.groupAverageList.some(
      (g: any) => g.name === 'Original Group Average' && g.selected === true,
    );
    const includePages = this.pagesList
      .filter((b: { selected: any }) => b.selected)
      .map((b: { Page_Code: any }) => ({
        Page_Code: b.Page_Code,
      }));
    const selectedBOC = this.bocList
      .filter((b: { selected: any }) => b.selected)
      .map((b: { Composite_Id: any; CompositeTypeDesc: any }) => ({
        Composite_Id: b.Composite_Id,
        CompositeTypeDesc: b.CompositeTypeDesc,
      }));

    const approvedBy = `${this.fincomdata.email}`;
    const currentDate = new Date().toISOString();
    const payload = {
      AdSheetList: [],
      Group_Composite_Id:
        this.customReportData.data.DealersMetrics.Group_Composite_Id,
      Created_By: approvedBy,
      Created_Date: currentDate,
      group_code: this.groupCode,
      gmonth: this.selectedDate.getMonth() + 1,
      gyear: this.selectedDate.getFullYear(),
      isFinalized: false,
      includeCustomAverage: includeCustomAverage,
      includeOriginalGroupAverage: includeOriginalGroupAverage,
      dealersList: selectedDealers,
      GroupAveragesList: [],
      BOCList: selectedBOC,
      Pages: includePages,
      PageGroupingList: this.generatePayload(),
      includeParticipationPage: false,
      IsN20: true,
    };

    const isLocalhost = window.location.hostname === 'localhost';
    let url = `${environment.generateCompositeExcel}`;
    if (isLocalhost) {
      url += `?code=${environment.functionappCode}`;
    }
    const response = await this.customReportService.groupCompositeExport(url, {
      ...payload,
    });
    if (response.success) {
      this.globalService.showToast(response.message, 'success');
    } else {
      this.globalService.showToast(
        'Failed to generate PDF report. Please try again.',
        'error',
      );
    }
  }
  get isAnyExcelPdfChecked(): boolean {
    return Object.values(this.checkboxModel).some((x: any) => x.E || x.P);
  }
  generatePayload() {
    const payload = this.pageGroupingList?.map(
      (item: { PageGrouping_Type_Id: string | number }) => {
        return {
          PageGrouping_Type_Id: item.PageGrouping_Type_Id,
          Excel: this.checkboxModel[item.PageGrouping_Type_Id].E,
          Pdf: this.checkboxModel[item.PageGrouping_Type_Id].P,
        };
      },
    );
    return payload;
  }
}
